export default __webpack_public_path__ + "static/media/spanish.851954b0.svg";